<template>
  <div class="review__entry">
    <div class="review__entry__content">
      <ImageComponent :src="`img/web/mocked-reviews-images/${review.image}.webp`" alt="Imagen de perfil" width="40"></ImageComponent>
      <div class="review__entry__wrapper">
        <p class="review__entry__name">
          {{ review.name }}
        </p>
        <p class="review__entry__number">
          {{ review.numberOfReviews }}
        </p>
        <div class="review__entry__details">
          <div class="review__entry__rate">
            <i class="review__entry__rate__icon"></i>
            <i class="review__entry__rate__icon"></i>
            <i class="review__entry__rate__icon"></i>
            <i class="review__entry__rate__icon"></i>
            <i class="review__entry__rate__icon"></i>
          </div>
          <span class="review__entry__rate__last-reviewed">
            {{ review.whenLastReview }}
          </span>
        </div>
      </div>
    </div>
    <p class="review__review">
      {{ review.review }}
    </p>
  </div>
</template>

<script>
import ImageComponent from '@/lego/components/images/Image.vue';

export default {
  components: {
    ImageComponent,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="postcss">
.review {
  &__entry {
    @apply flex flex-col rounded-md mr-nano lg:mr-0 xl:mr-quark p-xxxs lg:p-0 lg:pr-xxxs xl:pr-0 lg:border-none border-hairline border-neutral-light lg:bg-neutral-lightest bg-neutral-white min-w-[20rem] lg:min-w-0;

    &__content {
      @apply flex flex-row;

      img {
        @apply w-sm h-sm mr-nano lg:w-md lg:h-md lg:mr-xxxs;
      }
    }

    &__wrapper {
      @apply w-full;
    }

    &__name {
      @apply style-overline-bold lg:style-body-bold text-neutral-ultradark;
    }

    &__number {
      @apply style-overline lg:style-body-sm text-neutral-medium;
    }

    &__details {
      @apply flex mt-nano;
    }

    &__rate {
      @apply relative inline-flex justify-around;

      &__icon {
        @apply icon icon-xxxs icon-star m-[.125rem];
      }

      &__last-reviewed {
        @apply text-neutral-medium lg:style-body-sm ml-micro style-overline;
      }
    }
  }

  &__review {
    @apply mt-micro lg:mt-xxs text-neutral-ultradark style-overline lg:style-body text-ellipsis line-clamp-5 lg:line-clamp-4 lg:ml-xl;
  }
}
</style>
